import { createSelector } from '@reduxjs/toolkit';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import {
    selectActivityContentLocale,
    selectExpandedAccordionFromDetailState,
    selectPurchaseNoticeContent,
    selectResultFromDetailState,
} from 'component/page/detail/store/detail.selectors';
import { mapAdditionalInfo } from 'component/page/detail/detailUtils';
import { CmsValue } from 'core/type/BootstrapConfig.types';
import { DetailContentOnToggleProps } from 'component/page/detail/DetailPageContent/DetailPageContent.selectors';
import { GenericContent } from 'gql/autogen/GenericContent';
import { ExpandedAccordionDict } from 'core/type/Details.types';

interface OwnProps {
    cms: CmsValue;
    additionalInformation: string[];
    contentLocale: string;
    purchaseNotice: GenericContent[];
    expandedAccordion: ExpandedAccordionDict;
}

export type AdditionalInformationProps = OwnProps & DetailContentOnToggleProps;
export type AdditionalInformationSectionModularProps = OwnProps;

export const mapAdditionalInformationProps = createSelector(
    selectCmsFromBootstrap,
    selectResultFromDetailState,
    selectActivityContentLocale,
    selectPurchaseNoticeContent,
    selectExpandedAccordionFromDetailState,
    (cms, detailResult, contentLocale, purchaseNotice, expandedAccordion): OwnProps => {
        const additionalInformation = mapAdditionalInfo(detailResult) || [];

        return { cms, additionalInformation, contentLocale, purchaseNotice, expandedAccordion };
    },
);
